import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TileService } from '../../../../widgets/services/tile.service';
import { ModalOptions, displayModalComponent } from '../../../../widgets/models';
import { HomeVideoModalComponent } from '../../../../sales-and-delivery/components/home-video-modal/home-video-modal.component';


@Component({
  selector: 'app-assessment-promo',
  standalone:true,
  imports:[],
  templateUrl: './assessment-promo.component.html',
  styleUrls: ['./assessment-promo.component.scss']
})
export class AssessmentPromoComponent implements OnInit {

  constructor(private modalService: NgbModal) {

  }

  ngOnInit(): void {
  }
  openVideoPopup() {
    let params: any[] = [];
    params.push("ESStory");
    let options: ModalOptions = {
      title: '',
      showSave: false,
      showCancel: true,
      showCross: false,
      showFullscreen: false,
    };

    displayModalComponent(HomeVideoModalComponent, 'lg', options, this.modalService, params);
  }
}
